export const user = {
    types: {
        ADMIN: "Administrador",
        MANAGER: "Gestor",
        TECHNICAL: "Técnico",
    },
    labels: {
        uninformed: "Não Informado",
    },
};
